import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { useTranslation } from "react-i18next";

const CrossIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" version="1.1">
    <g id="surface1">
      <path
        style={{
          stroke: "none",
          fillRule: "evenodd",
          fill: "rgb(75.686275%,75.294118%,75.294118%)",
          fillOpacity: 1,
        }}
        d="M 14 28 C 21.730469 28 28 21.730469 28 14 C 28 6.269531 21.730469 0 14 0 C 6.269531 0 0 6.269531 0 14 C 0 21.730469 6.269531 28 14 28 Z M 14 28 "
      />
      <path
        style={{ stroke: "none", fillRule: "evenodd", fill: "rgb(100%,100%,100%)", fillOpacity: 1 }}
        d="M 21 8.410156 L 19.589844 7 L 14 12.589844 L 8.410156 7 L 7 8.410156 L 12.589844 14 L 7 19.589844 L 8.410156 21 L 14 15.410156 L 19.589844 21 L 21 19.589844 L 15.410156 14 Z M 21 8.410156 "
      />
    </g>
  </svg>
);
const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" version="1.1">
    <g id="surface1">
      <path
        style={{ stroke: "none", fillRule: "evenodd", fill: "rgb(0%,53.72549%,23.921569%)", fillOpacity: 1 }}
        d="M 14 28 C 21.730469 28 28 21.730469 28 14 C 28 6.269531 21.730469 0 14 0 C 6.269531 0 0 6.269531 0 14 C 0 21.730469 6.269531 28 14 28 Z M 14 28 "
      />
      <path
        style={{ stroke: "none", fillRule: "evenodd", fill: "rgb(100%,100%,100%)", fillOpacity: 1 }}
        d="M 10.9375 18.003906 L 6.957031 13.996094 L 5.601562 15.351562 L 10.9375 20.71875 L 22.398438 9.195312 L 21.054688 7.839844 Z M 10.9375 18.003906 "
      />
    </g>
  </svg>
);

export const MediasRegistrationBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="scha__register-free__banner">
      <div className="scha__register-free__banner__left-box" />
      <div className="scha__register-free__banner__right-box" />

      <div className={"scha__register-free__banner__logo"} style={{ gridColumn: 2, gridRow: 1 }}>
        <MediasLogo variant="general" />
      </div>
      <div className={"scha__register-free__banner__logo"} style={{ gridColumn: 3, gridRow: 1 }}>
        <MediasLogo variant="plus" />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 2 }}>
        {t("page.registerForFree.baner.all")}
      </div>
      <div className="scha__register-free__banner__label-table" style={{ gridColumn: 2, gridRow: 2 }}>
        {t("page.registerForFree.baner.limited")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 2 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 3 }}>
        {t("page.registerForFree.banner.lc")}
      </div>
      <div className="scha__register-free__banner__label-table" style={{ gridColumn: 2, gridRow: 3 }}>
        {t("page.registerForFree.baner.limited")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 3 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 4 }}>
        {t("page.registerForFree.baner.cad")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 4 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 4 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 5 }}>
        {t("page.registerForFree.baner.saveLinear")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 5 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 5 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 6 }}>
        {t("page.registerForFree.baner.compareProducts")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 6 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 6 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 7 }}>
        {t("page.registerForFree.baner.trainingCampus")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 7 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 7 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 8 }}>
        {t("page.registerForFree.banner.keep.new")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 8 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 8 }}>
        <CheckIcon />
      </div>

      <div className="scha__register-free__banner__title" style={{ gridColumn: 1, gridRow: 9 }}>
        {t("page.registerForFree.banner.send.new")}
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 2, gridRow: 9 }}>
        <CrossIcon />
      </div>
      <div className="scha__register-free__banner__icon" style={{ gridColumn: 3, gridRow: 9 }}>
        <CheckIcon />
      </div>
    </div>
  );
};
